import {
  getWebHookDeleteError,
  getWebHookDeleteSuccess,
  getWebHookError,
  getWebHookInsertError,
  getWebHookInsertSuccess,
  getWebHookProcessListError,
  getWebHookProcessListSuccess,
  getWebHookSuccess,
  getWebHookUpdateError,
  getWebHookUpdateSuccess,
  togglePageLoader,
} from "store/actions"
import { call, put, takeEvery } from "redux-saga/effects"
import toast from "toastr"
// Login Redux States
import {
  webhooks,
  webhooksDelete,
  webhooksInsert,
  webhooksUpdate,
  webhookslist,
} from "helpers/backend_helper"
import {
  GET_WEB_HOOKS,
  GET_WEB_HOOKS_PROCESS_LIST,
  POST_WEB_HOOKS_INSERT,
  POST_WEB_HOOKS_UPDATE,
  PUT_WEB_HOOKS_DELETE,
} from "./actionType"

//get dropdown list  weebhok list saga
function* getweebHookProcessList() {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(webhookslist)
    if (response.statusCode === 200) {
      yield put(getWebHookProcessListSuccess(response))
      yield put(togglePageLoader(false))
    } else {
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getWebHookProcessListError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}

//get  data weebhok list saga
function* getweebHook({ params: data }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(webhooks, data)
    if (response.statusCode === 200) {
      yield put(getWebHookSuccess(response))
      yield put(togglePageLoader(false))
    } else {
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getWebHookError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}

//post  data insert weebhok list saga
function* postweebHookInsert({ payload }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(webhooksInsert, payload)
    if (response.statusCode === 200) {
      yield put(getWebHookInsertSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
    } else {
      toast.error(response?.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getWebHookInsertError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}
//post  data update weebhok list saga
function* postweebHookUpdate({ payload }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(webhooksUpdate, payload)
    if (response.statusCode === 200) {
      yield put(getWebHookUpdateSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
    } else {
      toast.error(response?.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getWebHookUpdateError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}
//post  data delete weebhok list saga
function* postweebHookDelete({ payload: id }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(webhooksDelete, id)
    if (response.statusCode === 200) {
      yield put(getWebHookDeleteSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
    } else {
      toast.error(response?.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getWebHookDeleteError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}
function* webHooks() {
  yield takeEvery(GET_WEB_HOOKS_PROCESS_LIST, getweebHookProcessList)
  yield takeEvery(GET_WEB_HOOKS, getweebHook)
  yield takeEvery(POST_WEB_HOOKS_INSERT, postweebHookInsert)
  yield takeEvery(POST_WEB_HOOKS_UPDATE, postweebHookUpdate)
  yield takeEvery(PUT_WEB_HOOKS_DELETE, postweebHookDelete)
}

export default webHooks
